import logoMatador from '../images/logo-matador.png';
import './Privacidad.css';

// La política de privacidad del juego. Antes estaba en el WordPress de
// winegang.es (/politica-de-privacidad-club-matador/), que se va a sustituir
// por la web nueva: aquí no depende de ella. Mismo texto, con el CIF y el
// código postal de Fortunato & Montresor corregidos.
export default function Privacidad() {
    return (
        <div className="privacidad">
            <header className="privacidad-cabecera">
                <img src={logoMatador} alt="Club Matador" className="privacidad-logo" />
                <span className="privacidad-con">con Winegang</span>
            </header>

            <article className="privacidad-texto">
                <h1>Política de privacidad</h1>

                <h2>1. Corresponsables del tratamiento</h2>
                <p>
                    Los datos personales recogidos a través de la participación en el juego de cata a
                    ciegas online disponible en <a href="https://matador.winegang.es/">matador.winegang.es</a> serán
                    tratados de forma conjunta por:
                </p>
                <dl>
                    <dt>Fortunato &amp; Montresor S.L. (Winegang)</dt>
                    <dd>CIF: B86471513</dd>
                    <dd>Domicilio: Calle José Miguel Guridi 3, portal 6, 4.º derecha, 28043 Madrid</dd>
                    <dd>Protección de datos: <a href="mailto:info@winegang.es">info@winegang.es</a></dd>
                </dl>
                <dl>
                    <dt>Asociación Club Matador</dt>
                    <dd>CIF: G86626397</dd>
                    <dd>Domicilio: Calle Jorge Juan 5, 28001 Madrid</dd>
                    <dd>Protección de datos: <a href="mailto:ana.ponce@clubmatador.com">ana.ponce@clubmatador.com</a></dd>
                </dl>
                <p>
                    Ambas entidades actúan como corresponsables del tratamiento conforme al artículo 26 del
                    RGPD y a la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los
                    derechos digitales.
                </p>

                <h2>2. Finalidades del tratamiento</h2>
                <ul>
                    <li>Gestionar la participación en la partida privada organizada en el juego online.</li>
                    <li>Comunicar los resultados y, en su caso, la entrega de premios.</li>
                    <li>
                        Enviar información comercial y promocional sobre productos y servicios de ambas
                        entidades, cada una de ellas a través de sus propios medios de contacto.
                    </li>
                </ul>

                <h2>3. Base jurídica</h2>
                <p>
                    El tratamiento se fundamenta en el consentimiento del usuario al inscribirse en la
                    partida y aceptar esta política de privacidad.
                </p>

                <h2>4. Derechos de los usuarios</h2>
                <p>
                    Los participantes podrán ejercer en cualquier momento sus derechos de acceso,
                    rectificación, supresión, limitación, portabilidad y oposición, así como revocar su
                    consentimiento, dirigiéndose indistintamente a cualquiera de las corresponsables:
                </p>
                <ul>
                    <li><a href="mailto:info@winegang.es">info@winegang.es</a></li>
                    <li><a href="mailto:ana.ponce@clubmatador.com">ana.ponce@clubmatador.com</a></li>
                </ul>

                <h2>5. Conservación de los datos</h2>
                <p>
                    Los datos se conservarán durante la vigencia de la partida privada y, posteriormente,
                    mientras se mantenga el consentimiento de los interesados para fines comerciales. Una
                    vez revocado, los datos quedarán bloqueados durante los plazos legales aplicables.
                </p>

                <h2>6. Comunicación de los aspectos esenciales</h2>
                <p>
                    Los aspectos esenciales del acuerdo de corresponsabilidad suscrito entre ambas
                    entidades están disponibles a solicitud de los interesados.
                </p>
            </article>
        </div>
    );
}
